import React from "react";

export function Card({ children, radius = "card", className }) {
  const classes = [
    "rma-nc-card",
    radius === "panel" ? "rma-nc-card--panel" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={classes}>{children}</div>;
}

export function CardTitle({ children, aside, className }) {
  const rowClasses = [
    "rma-nc-card-title-row",
    !aside ? "rma-nc-card-title-row--simple" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rowClasses}>
      <h3 className="rma-nc-card-title">{children}</h3>
      {aside}
    </div>
  );
}

// Small uppercase heading for a group of fields inside a card, e.g. "Address".
export function SectionLabel({ children, className }) {
  const classes = ["rma-nc-section-label", className].filter(Boolean).join(" ");

  return <div className={classes}>{children}</div>;
}
